module.exports = __webpack_public_path__ + "img/hydroscopic-absorption.5619bc4.svg";